"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fabric = require("./libs/fabric.min");

var _UA = _interopRequireDefault(require("../UA"));

var _urlHelper = _interopRequireDefault(require("../urlHelper"));

var _versionHelper = _interopRequireDefault(require("../versionHelper"));

var _IssJsBridge = _interopRequireDefault(require("../IssJsBridge"));

var _SellerIssJsBridge = _interopRequireDefault(require("../SellerIssJsBridge"));

var _jsonHelper = _interopRequireDefault(require("../jsonHelper"));

var _requestHelper = _interopRequireDefault(require("../requestHelper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var requestHandle = _requestHelper["default"].requestHandle;
var deepGet = _jsonHelper["default"].deepGet;
var getQueryString = _urlHelper["default"].getQueryString;

var _getSourceName = function _getSourceName() {
  if (_UA["default"].env.shanSong_userApp) {
    if (_UA["default"].env.shanSong_userApp_android) {
      return '用户APP(安卓)';
    } else {
      return '用户APP(ios)';
    }
  }

  if (_UA["default"].env.shanSong_redBookMini) {
    return '小红书小程序';
  }

  if (_UA["default"].env.wxMiniProgram) {
    return '微信小程序';
  }

  if (_UA["default"].env.ali_mini) {
    return '支付宝小程序';
  }

  if (_UA["default"].env.ali_gaode) {
    return '高德小程序';
  }

  if (_UA["default"].env.ali_uc) {
    return 'uc小程序';
  }

  if (_UA["default"].env.ali_quark) {
    return '夸克小程序';
  }

  if (_UA["default"].env.swanApp) {
    return '百度小程序';
  }

  if (_UA["default"].env.douYinMini) {
    return '抖音小程序';
  }

  if (_UA["default"].env.hwquickApp) {
    return '华为快应用';
  }

  if (_UA["default"].env.shanSong_sellerApp) {
    if (_UA["default"].env.shanSong_sellerApp_android) {
      return '商家APP(安卓)';
    } else {
      return '商家APP(ios)';
    }
  }

  if (_UA["default"].env.userPC) {
    return '官网PC';
  }

  return '用户侧-其他';
};

var getUserCityAndMobile = function getUserCityAndMobile() {
  var mobile = '';
  var city = '';
  var cityId = '';
  var real_name = '';
  var mobile_phone = '';
  var foreignID = '';

  try {
    if (_UA["default"].env.wxMiniProgram || _UA["default"].env.shanSong_redBookMini || _UA["default"].env.ali_uc || _UA["default"].env.ali_quark || _UA["default"].env.ali_mini || _UA["default"].env.douYinMini) {
      mobile = getQueryString('userMobile') || '';
      city = decodeURIComponent(escape(getQueryString('indexCityName') || ''));
      cityId = getQueryString('cityCode') || '';
      real_name = decodeURIComponent(escape(getQueryString('nickName') || ''));
      mobile_phone = mobile || '';
      foreignID = getQueryString('uid') || '';
    } else if (_UA["default"].env.shanSong_userApp) {
      try {
        var cityInfo = _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.getCityInfo);

        city = deepGet(cityInfo, 'data.currentCity.cityName', '');
        cityId = deepGet(cityInfo, 'data.currentCity.cityId', '');
      } catch (error) {
        city = '';
        cityId = '';
        console.error(error);
      }

      try {
        var userInfo = _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.getAppUserInfo);

        mobile = deepGet(userInfo, 'data.encryptMobile', '');
        mobile_phone = mobile;
        real_name = deepGet(userInfo, 'data.nickName', '');
      } catch (error) {
        mobile = '';
        mobile_phone = '';
        real_name = '';
        console.error(error);
      }

      try {
        var res = _IssJsBridge["default"].call(_IssJsBridge["default"].jsBridgeActions.getDeviceInfo);

        var beidouInfo = JSON.parse(res.data.beidouInfo);
        console.log(beidouInfo);
        foreignID = beidouInfo.uid;
      } catch (error) {
        foreignID = '';
        console.error(error);
      }
    } else if (_UA["default"].env.shanSong_sellerApp) {
      if (_versionHelper["default"].cur$Version['<']('4.2.70')) {
        mobile = getQueryString('userMobile') || '';
        city = decodeURIComponent(escape(getQueryString('cityName') || ''));
        cityId = getQueryString('cityCode') || '';
        real_name = mobile;
        mobile_phone = mobile;
      } else {
        var _IssSellerJsBridge$ca = _SellerIssJsBridge["default"].call(_SellerIssJsBridge["default"].jsBridgeActions.accountInfo),
            _IssSellerJsBridge$ca2 = _IssSellerJsBridge$ca.data,
            data = _IssSellerJsBridge$ca2 === void 0 ? {} : _IssSellerJsBridge$ca2;

        mobile = data.storeId || '';
        city = data.cityName || '';
        cityId = data.cityId || '';
        real_name = data.storeName || '';
        mobile_phone = data.contactPhone || [data.phoneAreaCode, data.phoneNumber, data.phoneSubNumber].filter(function (v) {
          return !!v;
        }).join('-') || '';
        foreignID = data.storeId || '';

        if (getQueryString('qyDebug')) {
          alert(JSON.stringify(data));
        }
      }
    } else if (_UA["default"].env.userPC) {
      var _userInfo;

      try {
        _userInfo = JSON.parse(localStorage.getItem('userInfo'));
      } catch (error) {
        _userInfo = {};
      }

      mobile = _userInfo.encryptMobile || localStorage.getItem('loginMobile') || '';
      city = localStorage.getItem('CityName') || '';
      cityId = localStorage.getItem('CityId') || '';
      real_name = _userInfo.nickName || window.qyUserName || '';
      mobile_phone = mobile;
      foreignID = _userInfo.userId || '';
    }

    return {
      mobile: mobile,
      city: city,
      cityId: cityId,
      real_name: real_name,
      mobile_phone: mobile_phone,
      foreignID: foreignID
    };
  } catch (error) {
    return {
      mobile: mobile,
      city: city,
      cityId: cityId,
      real_name: real_name,
      mobile_phone: mobile_phone,
      foreignID: foreignID
    };
  }
};

var QYServiceInit = function QYServiceInit(dom) {
  var domClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };
  var openNewPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var fetchParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    token: '',
    clientId: '',
    userId: ''
  };
  var onError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (err) {
    alert(err);
  };
  var testDomain = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  (function (w, d, n, a, j) {
    w[n] = w[n] || function () {
      (w[n].a = w[n].a || []).push(arguments);
    };

    j = d.createElement('script');
    j.async = false;

    if (testDomain) {
      j.src = 'https://qiyukfys.qiyukf.com/script/08ba67fedd630fa731d8218faca5ec85.js?hiddden=1&subdomain=1';
    } else {
      j.src = 'https://bjtcbykjyxgs.qiyukf.com/script/c30619688812fbcc7f4cc49eb3675e9c.js?hiddden=1&subdomain=1';
    }

    d.body.append(j);
  })(window, document, 'ysf');

  document.querySelector(dom).addEventListener('click', (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
    var _getUserCityAndMobile, mobile, city, real_name, mobile_phone, foreignID, res, logData, data;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (domClick instanceof Function) {
              domClick();
            }

            if (!this.btnLoading) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            this.btnLoading = true;
            _context.prev = 4;
            _getUserCityAndMobile = getUserCityAndMobile(), mobile = _getUserCityAndMobile.mobile, city = _getUserCityAndMobile.city, real_name = _getUserCityAndMobile.real_name, mobile_phone = _getUserCityAndMobile.mobile_phone, foreignID = _getUserCityAndMobile.foreignID;
            _context.next = 8;
            return requestHandle({
              url: '/csexternal/qiyu/auth/getAuthToken',
              headers: {
                'Content-Type': 'application/json'
              }
            }, _objectSpread(_objectSpread({}, fetchParams), {}, {
              userId: mobile
            }), 'POST');

          case 8:
            res = _context.sent;

            if (res.code === 200) {
              logData = {
                mobile: mobile,
                city: city,
                real_name: real_name,
                mobile_phone: mobile_phone,
                foreignID: foreignID
              };
              console.log('客服透传信息', logData);

              if (getQueryString('qyDebug')) {
                alert(JSON.stringify(logData));
              }

              try {
                data = [{
                  key: 'real_name',
                  value: real_name || '/'
                }, {
                  key: 'mobile_phone',
                  value: mobile_phone || '/'
                }, {
                  index: 0,
                  key: 'txt_source',
                  label: '来源',
                  value: _getSourceName()
                }, {
                  index: 1,
                  key: 'txt_city',
                  label: '城市',
                  value: city || '/'
                }, {
                  index: 2,
                  key: 'txt_userType',
                  label: '身份归属',
                  value: _UA["default"].env.shanSong_sellerApp ? '商家用户' : '个人用户'
                }, {
                  index: 3,
                  key: 'txt_foreignID',
                  label: 'foreignID',
                  value: foreignID || '/'
                }];

                if (_UA["default"].env.shanSong_sellerApp) {
                  data = [].concat((0, _toConsumableArray2["default"])(data), [{
                    type: 'crm_param',
                    index: 4,
                    key: 'storeId',
                    label: 'storeId',
                    value: foreignID || ''
                  }, {
                    type: 'crm_param',
                    index: 5,
                    key: 'mobile',
                    label: 'mobile',
                    value: mobile_phone || ''
                  }, {
                    type: 'crm_param',
                    index: 6,
                    key: 'clientType',
                    label: 'clientType',
                    value: 4
                  }]);
                } else {
                  data = [].concat((0, _toConsumableArray2["default"])(data), [{
                    type: 'crm_param',
                    index: 4,
                    key: 'uid',
                    label: 'uid',
                    value: foreignID || ''
                  }, {
                    type: 'crm_param',
                    index: 5,
                    key: 'mobile',
                    label: 'mobile',
                    value: mobile_phone || ''
                  }, {
                    type: 'crm_param',
                    index: 6,
                    key: 'clientType',
                    label: 'clientType',
                    value: 2
                  }]);
                }

                window.ysf('config', {
                  authToken: res.token,
                  uid: mobile || res.token,
                  name: mobile,
                  email: '',
                  mobile: mobile,
                  data: JSON.stringify(data),
                  success: function success() {
                    console.log('上传成功');

                    if (openNewPage) {
                      window.open(window.ysf('url'));
                    } else {
                      location.href = window.ysf('url');
                    }
                  },
                  error: function error() {
                    console.log('上传失败');
                  }
                });
              } catch (error) {
                console.error(error);
              }
            } else {
              onError(res, 'success');
            }

            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);
            onError(_context.t0);

          case 15:
            _context.prev = 15;
            this.btnLoading = false;
            return _context.finish(15);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 12, 15, 18]]);
  })));
};

var _default = {
  fabric: _fabric.fabric,
  QYServiceInit: QYServiceInit,
  getUserCityAndMobile: getUserCityAndMobile
};
exports["default"] = _default;